import React, { useEffect, useState } from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import Translation from '../../global/Translation'
import ReactTooltip from 'react-tooltip'
import copyToClipboardIcon from '../../../assets/img/components/copy-to-clipboard.svg'
import bannerEclosImg from '../../../assets/img/banner-eclos-voucher/banner-eclos-voucher__catalog.png'

defineMessages({
    for_any_quantity_of_eclos_slabs: {
        id: 'for_any_quantity_of_eclos_slabs',
        description: 'for_any_quantity_of_eclos_slabs',
        defaultMessage: 'for any quantity of Éclos® slabs.'
    },
    valid_only_on_eclos_slabs: {
        id: 'valid_only_on_eclos_slabs',
        description: 'valid_only_on_eclos_slabs',
        defaultMessage: 'Valid only on Éclos® slabs'
    }
})

const CheckoutBannerEclosVoucher = props => {
    const { intl, promotionCode } = props
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768)
        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const _eclosData = {
        bodyText: intl.formatMessage({ id: 'for_any_quantity_of_eclos_slabs', defaultMessage: 'for any quantity of Éclos® slabs.' }),
        smallText: intl.formatMessage({ id: 'valid_only_on_eclos_slabs', defaultMessage: 'Valid only on Éclos® slabs' })
    }

    return (
        <div
            className="small-banner-voucher-promo small-voucher-eclos"
            style={{
                backgroundImage: `url(${bannerEclosImg})`,
                backgroundSize: 'cover',
                backgroundPosition: isMobile ? 'center center' : 'center left',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <div className="small-voucher-eclos__overlay"></div>
            <div className="banner-title-content">
                <h3>
                    <Translation id="exclusive_offer_for_eclos_customers" defaultMessage="Exclusive Offer for Éclos® Customers!" />
                </h3>
            </div>
            <div className="banner-card-content">
                <Card
                    percentAmount={10}
                    percentAmountTitle={_eclosData.percentAmountTitle}
                    promotionCode={promotionCode}
                    bodyText={_eclosData.bodyText}
                    smallText={_eclosData.smallText}
                    intl={intl}
                />
            </div>
            <div style={{ width: '100%' }}>
                <span className="banner-bottom-text">
                    <Translation id="eclos_voucher_valid_through" defaultMessage="Valid through December 31, 2026." />
                </span>
            </div>
        </div>
    )
}

const Card = props => {
    const { percentAmount, promotionCode, bodyText, smallText, intl } = props
    const [promotionCopied, setPromotionCopied] = useState(false)

    const copyPromotionCodeOnClick = e => {
        e.preventDefault()
        navigator.clipboard.writeText(promotionCode).then(() => {
            setPromotionCopied(true)
            ReactTooltip.hide()
            ReactTooltip.show()
            setTimeout(() => {
                setPromotionCopied(false)
                ReactTooltip.hide()
            }, 3000)
        })
    }

    return (
        <div className="voucher-promo-card">
            <div>
                <div>
                    <h5>
                        {percentAmount}%* <Translation id="off" defaultMessage="off" />.
                    </h5>
                </div>
                <div className="enter-promotion-code">
                    <span>
                        <Translation id="enter" defaultMessage="Enter" />: {promotionCode}
                        <button
                            onClick={copyPromotionCodeOnClick}
                            data-tip={promotionCopied ? intl.formatMessage({ id: 'copied', defaultMessage: 'Copied' }) : intl.formatMessage({ id: 'copy_to_clipboard', defaultMessage: 'Copy to clipboard' })}
                            className="copy-to-clipboard__btn"
                        >
                            <img src={copyToClipboardIcon} alt="copy to clipboard" />
                        </button>
                        <ReactTooltip
                            effect="solid"
                            place="top"
                        />
                    </span>
                </div>
            </div>
            {bodyText && (
                <div>
                    <p>{bodyText}</p>
                </div>
            )}

            {smallText && (
                <div>
                    <p className="mt-1">
                        <small>* {smallText}</small>
                    </p>
                </div>
            )}
        </div>
    )
}

export default injectIntl(CheckoutBannerEclosVoucher)
